import { TextField } from "@mui/material";
import EditCoachProps from "../../../interface/editCoachProps";
import React from "react";
import { CoachListContext } from "../../../context/coachListContext";
import CoachProps from "../../../interface/coachProps";

const RenderTeamsLinkInput = (): React.JSX.Element => {
  const {
    setEditCoach,
    editCoach,
  }: {
    setEditCoach: (editCoach: {
      showDialog: boolean;
      coach: CoachProps;
    }) => void;
    editCoach: EditCoachProps;
  } = React.useContext(CoachListContext);

  return (
    <TextField
      multiline
      focused
      color="success"
      error={editCoach.coach.teams_link.length === 0}
      helperText={
        editCoach.coach.teams_link.length === 0
          ? "Bitte gib einen Teams-Link ein"
          : ""
      }
      sx={{
        "& .MuiInputBase-root": {
          color:
            editCoach.coach.teams_link.length > 0
              ? (theme) => theme.palette.success.main
              : (theme) => theme.palette.error.main,
        },
      }}
      required
      fullWidth
      type="text"
      id="teams-link-input"
      label="Teams-Link"
      variant="outlined"
      value={editCoach.coach.teams_link}
      onChange={(e) => {
        setEditCoach({
          ...editCoach,
          coach: {
            ...editCoach.coach,
            teams_link: e.target.value,
          },
        });
      }}
    />
  );
};

export default RenderTeamsLinkInput;
